import React from "react";
import { MdEast, MdOutlineSupervisedUserCircle } from "react-icons/md";
import { ContactListType, SchoolListType } from "utils/interfaces";

interface SelectSchoolCardProps {
  school: SchoolListType;
  selectAction: (school: SchoolListType) => void;
}

const SelectSchoolCard: React.FC<SelectSchoolCardProps> = ({ school, selectAction}) => {
  /**
   * Function used to operate on click of the checkbox
   */
  const handleOnClick = () => {
    selectAction(school);
  };

  return (
    <button
      className="self-stretch p-3 bg-neutral-25 hover:bg-neutral-50 ease-in-out duration-150 border text-start border-transparent rounded-xl justify-start items-center gap-3 inline-flex cursor-pointer"
      onClick={handleOnClick}
    >
      <div className="min-w-0 grow shrink basis-0 flex-col justify-center items-start gap-2 inline-flex">
        <div className="self-stretch justify-start items-center gap-2 inline-flex">
          <div className="grow shrink basis-0 text-neutral-700 text-sm font-semibold font-sans leading-[17px]">
            {school.name}
          </div>
        </div>
        <div className="self-stretch justify-start items-center gap-3 inline-flex overflow-hidden">
          <div className="self-stretch justify-start items-center inline-flex gap-1">
            <div className="w-4 h-4 relative">
              <MdOutlineSupervisedUserCircle className="w-full h-full fill-neutral-500" />
            </div>
            <div className="self-stretch justify-start items-center gap-3 inline-flex overflow-hidden">
              {school.contacts && school.contacts.length > 0 ? (
                // Added the slice option in order to make it flexible if we need to add all of the contacts
                school.contacts.slice(0,1).map(
                  (teacher: ContactListType, index: number) => (
                    <React.Fragment key={index}>
                      {index > 0 && (
                        <div className="self-stretch justify-start items-start gap-2 flex">
                          <div className="w-px self-stretch bg-neutral-200" />
                        </div>
                      )}
                      <div className="text-neutral-500 text-xs font-normal font-inter leading-[14px] whitespace-nowrap">
                        {`${teacher.firstName} ${teacher.lastName}`}
                      </div>
                    </React.Fragment>
                  )
                )
              ) : (
                <div className="text-neutral-500 text-xs font-normal font-inter leading-[14px] whitespace-nowrap">
                  -
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="p-2 bg-neutral-100 rounded-full justify-start items-start gap-2 flex flex-shrink-0">
        <div className="w-4 h-4 relative">
          <MdEast className="w-full h-full fill-neutral-500" />
        </div>
      </div>
    </button>
  );
};

export default SelectSchoolCard;
